import { Directive, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { TrcAlphaStringPipe } from '../pipes/alpha-string.pipe';

@Directive({
    selector: '[ngModel][jhiAlphaString]'
})
export class CustomAlphaStringDirective implements OnInit, OnDestroy {

    constructor(private alphaStringPipe: TrcAlphaStringPipe, private el: ElementRef) {
    }

    ngOnInit(): void {
        this.el.nativeElement.addEventListener('input', this.listenerFunction.bind(this), true);
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener('input', this.listenerFunction);
    }

    listenerFunction(event: any) {
        event.target.value = this.getNormalizedValue(event.target.value);
    }

    getNormalizedValue(value: string): string {
        return this.alphaStringPipe.transform(value);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/alpha-string.directive.ts